import {useQuery} from '@tanstack/react-query';
import {getMyInquiryDetail} from '@/api/help/my-inquiry';
import {checkIsObjection, formatCategory} from '@/utils/help/inquiry';

export const myInquiryInitialData = {
  category: '',
  question: {title: '', contents: '', createdDate: ''},
  answer: {contents: '', createdDate: ''},
  isError: false,
  isObjection: false,
};

export const useGetMyInquiryDetail = ({inquiryId}: {inquiryId: string}) => {
  return useQuery({
    queryKey: ['help', 'my-inquiry-detail', inquiryId],
    queryFn: () => getMyInquiryDetail({inquiryId}),
    // 에러인 경우 errorCode(내 글이 아닌 경우 -1001)와 errorMessage 반환
    // 정상인 경우 errorCode: 0, data 반환
    select: (data) => {
      if (data.errorCode !== 0) {
        return {
          ...myInquiryInitialData,
          isError: true,
        };
      }

      const {commonInfo, questionList, answerEndList} = data.data;
      const {nodePath, nodeId, nodeName} = commonInfo;
      return {
        category: `${formatCategory(nodePath || '', nodeId || '')} > ${nodeName}`,
        question: questionList[0] || myInquiryInitialData.question,
        answer: answerEndList[0] || myInquiryInitialData.answer,
        isError: false,
        isObjection: checkIsObjection(nodeId || ''),
      };
    },
  });
};
